import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const WORDS = [
  { word: "Build.", desc: "Turn ideas into digital products." },
  { word: "Operate.", desc: "Keep systems reliable and secure." },
  { word: "Automate.", desc: "Replace repetitive work with intelligence." },
  { word: "Grow.", desc: "Continuously improve business outcomes." },
];

const Word = ({ word, desc, index }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start 85%", "start 35%"] });
  const opacity = useTransform(scrollYProgress, [0, 1], [0.12, 1]);
  const x = useTransform(scrollYProgress, [0, 1], [60, 0]);
  const descOpacity = useTransform(scrollYProgress, [0.6, 1], [0, 1]);

  return (
    <div ref={ref} className="flex flex-col sm:flex-row sm:items-baseline gap-2 sm:gap-10">
      <motion.h3
        style={{ opacity, x }}
        data-testid={`philosophy-word-${index}`}
        className={`font-display font-extrabold tracking-tighter leading-none text-6xl sm:text-8xl lg:text-9xl ${index % 2 === 0 ? "jx-gradient-text" : "jx-outline-text-light"}`}
      >
        {word}
      </motion.h3>
      <motion.p style={{ opacity: descOpacity }} className="text-white/55 text-base sm:text-lg max-w-xs">
        {desc}
      </motion.p>
    </div>
  );
};

export const Philosophy = () => (
  <section data-testid="philosophy-section" className="py-28 sm:py-40 bg-jx-night text-white relative overflow-hidden">
    <div className="pointer-events-none absolute top-1/3 -right-40 w-[560px] h-[560px] rounded-full bg-jx-purple/25 blur-[150px]" />
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <p className="jx-overline text-jx-copper mb-16">Brand Philosophy</p>
      <div className="flex flex-col gap-10 sm:gap-6">
        {WORDS.map((w, i) => (
          <Word key={w.word} {...w} index={i} />
        ))}
      </div>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        className="mt-20 text-xl sm:text-2xl font-display font-medium text-white/70 tracking-tight"
        data-testid="philosophy-statement"
      >
        Four capabilities. <span className="jx-gradient-text font-bold">One connected technology partner.</span>
      </motion.p>
    </div>
  </section>
);
